import { render, staticRenderFns } from "./AncientIndividualSampleDetailMobile.vue?vue&type=template&id=2e0c2d02&scoped=true"
import script from "./AncientIndividualSampleDetailMobile.vue?vue&type=script&lang=js"
export * from "./AncientIndividualSampleDetailMobile.vue?vue&type=script&lang=js"
import style0 from "./AncientIndividualSampleDetailMobile.vue?vue&type=style&index=0&id=2e0c2d02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0c2d02",
  null
  
)

export default component.exports